<template>
  <rect x="25" y="25" width="100" height="50" rx="0" ry="0" stroke="none" />
</template>
